import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/admin/issues",
		component: lazy(() => import("./AdminSystemIssuesPage")),
	},
]);
